export type IDlsVersionMeta<
  Current extends string = string,
  Previous extends string = string
> = {
  component: string;
  current: Current;
} & ( // Two named slots, no array — the type IS the max-2 limit.
  | { previous?: never; default?: never }
  | {
      previous: Previous;
      /**
       * Version unversioned call sites resolve to. Required with `previous`:
       * adding a new version must never silently move existing call sites.
       * Lifecycle: introduce (`default` = old version) → migrate call sites
       * with explicit `v` → flip `default` to `current` → delete `previous`.
       */
      default: Current | Previous;
    }
);

/**
 * Identity helper that preserves the literal types of a component's version
 * metadata. Must be called with a plain object literal — the
 * `dls-max-component-versions` lint rule parses it statically.
 */
export const defineVersions = <const M extends IDlsVersionMeta>(meta: M): M =>
  meta;
